var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWuding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_25_3904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 645",
    d: "M8.36504 1.77252L1 6.97818V12.8008L8.36504 7.74939L16 12.8008V6.97818L8.36504 1.77252Z",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 646",
    d: "M1 10.5257L8.36504 5.4743L16 10.5257",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 647",
    d: "M8.40356 5.4743V1.8111",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 648",
    d: "M2.81226 11.5669L2.81226 14.2276",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 649",
    d: "M14.1299 11.5669L14.1299 14.2276",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_3904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWuding);
export default __webpack_public_path__ + "static/media/wuding.c5485ee69d5aa9c13a4b9a74262effc1.svg";
export { ForwardRef as ReactComponent };